import { create } from "zustand";
import type { ContentCard } from "../types";

type ContentCardsStore = {
  // null until Braze has answered for the first time, which is how the
  // consuming surfaces tell "still waiting" apart from "nothing to show".
  cards: ContentCard[] | null;
};

type ContentCardsActions = {
  setCards: (cards: ContentCard[]) => void;
};

type ContentCardsState = ContentCardsStore & ContentCardsActions;

const initialState: ContentCardsStore = {
  cards: null,
};

export const useContentCardsStore = create<ContentCardsState>()((set) => ({
  ...initialState,
  setCards: (cards) => set({ cards }),
}));
